// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__89Oof","content":"styles_content__--z2K","tableWrap":"styles_tableWrap__2ZrCF"};